import React from "react";

import ModalContent from "../modal/modalContent";

import edit from "./../../../../../img/edit.png";

import "./cardContent.scss";

const CardContent = ({
  cardIndex,
  name,
  icon,
  title,
  value,
  unit,
  modal,
  handleClose,
  activeModal,
  updateInfo,
  handleOpen,
  getAnswerValueByName,
  updateAnswer,
}) => {
  return (
    <div key={cardIndex} className="options_container mt-1-5">
      <img src={icon} alt="" />
      {title}
      <p className="">
        <span id={name} style={{ fontSize: "1.2rem" }}>
          {value || value === 0 ? value : ""}
        </span>
        {unit ? unit : ""}
      </p>
      <button>
        <img src={edit} onClick={(event) => handleOpen(event, name)} alt="" />

        <ModalContent
          modal={modal}
          updateInfo={updateInfo}
          activeModal={activeModal}
          handleClose={handleClose}
          getAnswerValueByName={getAnswerValueByName}
          updateAnswer={updateAnswer}
        />
      </button>
    </div>
  );
};

export default CardContent;
